import { useEffect, useState } from "react";
import StorageService from "../services/StorageService";
import { fetchMarketplaceCartCount } from "../services/marketplaceCart.service";

export default function useMarketplaceCartCount() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let active = true;

    const refresh = async () => {
      if (!StorageService.isAuthenticated()) {
        if (active) setCount(0);
        return;
      }
      try {
        const next = await fetchMarketplaceCartCount();
        if (active) setCount(next);
      } catch {
        if (active) setCount(0);
      }
    };

    void refresh();
    window.addEventListener("marketplace-cart-updated", refresh);
    window.addEventListener("storage", refresh);
    return () => {
      active = false;
      window.removeEventListener("marketplace-cart-updated", refresh);
      window.removeEventListener("storage", refresh);
    };
  }, []);

  return count;
}
